import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import { useSelector } from "react-redux";
import axios from "axios";

type PasswordField = "password" | "confirmPassword";

interface EditCompanyProps {
  Address1: string;
  Address2: string;
  City: string;
  Company_Name: string;
  Country: string;
  CreatedDate: string;
  Email: string;
  Facebook: string;
  Image: string;
  Image2: string;
  Instagram: string;
  Linkedin: string;
  Location: string;
  Phone: string;
  Pincode: string;
  State: string;
  Status: string;
  Twitter: string;
  Whatsapp: string;
  key: any;
  Password: string;
  signature: string;
  logo: string;
}

const defaultCompanyData: EditCompanyProps = {
  Address1: "",
  Address2: "",
  City: "",
  Company_Name: "",
  Country: "",
  CreatedDate: "",
  Email: "",
  Facebook: "",
  Image: "",
  Image2: "",
  Instagram: "",
  Linkedin: "",
  Location: "",
  Phone: "",
  Pincode: "",
  State: "",
  Status: "",
  Twitter: "",
  Whatsapp: "",
  key: 0,
  Password: "",
  signature: "",
  logo: "",
};

const EditCompany = ({
  data = defaultCompanyData,
}: {
  data?: EditCompanyProps;
}) => {
  const [selectedCompanyEdit, setSelectedCompanyEdit] = useState<any | null>(
    data
  );
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setSelectedCompanyEdit(data);
  }, [data]); // Run this effect whenever 'data' changes

  const [isLoading, setIsLoading] = useState(false); // state to track loading

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const generateRandomPassword = () => {
    const length = 12; // Desired length of the password
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let randomPassword = "";
    for (let i = 0; i < length; i++) {
      randomPassword += charset.charAt(
        Math.floor(Math.random() * charset.length)
      );
    }
    setSelectedCompanyEdit((prev: any) => ({
      ...prev,
      Password: randomPassword,
    }));
  };

  const updateDetails = async () => {
    // Form data to be sent to API

    try {
      setIsLoading(true);

      var dataToSend = {
        signature: selectedCompanyEdit.signature,
        companyName: selectedCompanyEdit.Company_Name,
        password: selectedCompanyEdit.Password,
        address1: selectedCompanyEdit.Address1,
        address2: selectedCompanyEdit.Address2,
        pincode: selectedCompanyEdit.Pincode,
        id: selectedCompanyEdit.key,
        logo: selectedCompanyEdit?.logo || selectedCompanyEdit?.Image || null,
      };

      const response = await api.post(
        "userService/updateChildCompany",
        dataToSend
      );

      showBasicAlert(response.data.message[0].msg);
      document.getElementById("close-company-edit-form");

      //Send email to customer about login details
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    } finally {
      setIsLoading(false); // hide loader after response
    }
  };

  const user = useSelector((state: any) => state.user.user);

  const uploadFileToCloudinary = async (file: File) => {
    const UPLOAD_PRESET: any = process.env.REACT_APP_UPLOAD_PRESET;
    const CLOUDINARY_URL = `${process.env.REACT_APP_API_CLOUDNIRY_URL}/${process.env.REACT_APP_CLOUD_NAME}/upload`;
    const FOLDER_PATH = "cms/profile_pic/" + user?.userDetails.id;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", FOLDER_PATH);

    try {
      const response = await axios.post(CLOUDINARY_URL, formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      showBasicAlert("Failed to upload file. Please try again.");
      return null;
    }
  };

  const handleFileChange = async (e: any) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile || !selectedFile.type.startsWith("image/")) {
      showBasicAlert("Please select a valid image file.");
      return;
    }

    // Set uploading state
    setIsUploadingImage(true);

    const result = await uploadFileToCloudinary(selectedFile);

    if (result?.secure_url) {
      setIsImageLoading(true);
      setSelectedCompanyEdit((prev: any) => ({
        ...prev,
        logo: result.secure_url,
        Image: result.secure_url,
        Image2: result.secure_url,
      }));
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    // Reset uploading state
    setIsUploadingImage(false);
  };

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
    showBasicAlert("Failed to load image. Please try again.");
  };

  if (selectedCompanyEdit != null) {
    return (
      <>
        {/* Edit Company */}
        <div className="modal fade" id="edit_company">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit New Company</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="contact-grids-tab">
                  <ul className="nav nav-underline" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="info-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#basic-info"
                        type="button"
                        role="tab"
                        aria-selected="true">
                        Basic Information
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#address"
                        type="button"
                        role="tab"
                        aria-selected="false">
                        Address
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="basic-info"
                    role="tabpanel"
                    aria-labelledby="info-tab"
                    tabIndex={0}>
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames position-relative">
                              {isImageLoading && (
                                <div className="position-absolute top-50 start-50 translate-middle">
                                  <div
                                    className="spinner-border spinner-border-sm text-primary"
                                    role="status">
                                    <span className="visually-hidden">
                                      Loading image...
                                    </span>
                                  </div>
                                </div>
                              )}
                              <img
                                src={
                                  selectedCompanyEdit?.logo ||
                                  selectedCompanyEdit?.Image ||
                                  "assets/img/users/user.png"
                                }
                                alt="Profile preview"
                                className="rounded-circle"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  opacity: isImageLoading ? 0.5 : 1,
                                }}
                                onLoad={handleImageLoad}
                                onError={handleImageError}
                              />
                            </div>
                            <div className="profile-upload">
                              <div className="mb-2">
                                <h6 className="mb-1">Upload Profile Image</h6>
                                <p className="fs-12">
                                  Image should be below 4 mb
                                </p>
                              </div>
                              <div className="profile-uploader d-flex align-items-center">
                                <div
                                  className={`drag-upload-btn btn btn-sm btn-primary me-2 ${
                                    isUploadingImage ? "uploading" : ""
                                  }`}>
                                  {isUploadingImage ? (
                                    <>
                                      <div
                                        className="spinner-border spinner-border-sm text-white me-1"
                                        role="status">
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                      Uploading...
                                    </>
                                  ) : (
                                    "Upload"
                                  )}
                                  <input
                                    ref={fileInputRef}
                                    name="file"
                                    type="file"
                                    accept="image/*"
                                    className="form-control image-sign"
                                    onChange={handleFileChange}
                                    disabled={isUploadingImage}
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: isUploadingImage
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  />
                                </div>
                                {selectedCompanyEdit?.logo &&
                                  !isUploadingImage && (
                                    <Link
                                      to="#"
                                      className="btn btn-light btn-sm"
                                      onClick={(e: any) => {
                                        e.preventDefault();
                                        setSelectedCompanyEdit((prev: any) => ({
                                          ...prev,
                                          logo: "",
                                          Image: "",
                                          Image2: "",
                                        }));
                                        if (fileInputRef.current) {
                                          fileInputRef.current.value = "";
                                        }
                                      }}>
                                      Cancel
                                    </Link>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Company Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="Company_Name"
                              value={selectedCompanyEdit?.Company_Name}
                              onChange={(e) => {
                                setSelectedCompanyEdit((prev: any) => ({
                                  ...prev,
                                  Company_Name: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                              type="text"
                              className="form-control"
                              value={data?.Email}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Phone Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={data?.Phone}
                              disabled
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Password <span className="text-danger"> *</span>
                            </label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.password
                                    ? "text"
                                    : "password"
                                }
                                className="pass-input form-control"
                                name="password"
                                value={selectedCompanyEdit?.Password}
                                onChange={(e) => {
                                  setSelectedCompanyEdit((prev: any) => ({
                                    ...prev,
                                    Password: e.target.value,
                                  }));
                                }}
                              />
                              <span
                                className={`ti toggle-passwords ${
                                  passwordVisibility.password
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                }`}
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }></span>
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary mt-2"
                              onClick={generateRandomPassword}>
                              Generate Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal">
                        Cancel
                      </button>
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn-primary"
                        onClick={() => {
                          updateDetails();
                        }}>
                        Save{" "}
                      </button>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="address"
                    role="tabpanel"
                    aria-labelledby="address-tab"
                    tabIndex={0}>
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Address 1 <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.Address1}
                              onChange={(e) => {
                                setSelectedCompanyEdit((prev: any) => ({
                                  ...prev,
                                  Address1: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Address 2 <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.Address2}
                              onChange={(e) => {
                                setSelectedCompanyEdit((prev: any) => ({
                                  ...prev,
                                  Address2: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Country <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.Country}
                              disabled
                            />
                          </div>
                        </div>

                        {/* State */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              State <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.State}
                              disabled
                            />
                          </div>
                        </div>

                        {/* City */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              City <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.City}
                              disabled
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Pincode <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedCompanyEdit?.Pincode}
                              onChange={(e) => {
                                setSelectedCompanyEdit((prev: any) => ({
                                  ...prev,
                                  Pincode: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                        id="close-company-edit-form">
                        Cancel
                      </button>
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn-primary"
                        onClick={() => {
                          updateDetails();
                        }}>
                        Save{" "}
                      </button>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="access"
                    role="tabpanel"
                    aria-labelledby="access-tab"
                    tabIndex={0}></div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Company */}
      </>
    );
  } else {
    return null;
  }
};

export default EditCompany;
